function pd_change_icon() {
    let swatch_preset = document.querySelector('.swatch-preset-969755')
    if (!swatch_preset) {
        console.log("swatch-king:", swatch_preset);
        return false
    }

    let swatch_custom_image_list = swatch_preset.querySelectorAll('.swatch-custom-image')
    if (!swatch_custom_image_list) {
        console.log("swatch_custom_image_list:", swatch_custom_image_list);
        return false
    }

    swatch_custom_image_list.forEach(el => {
        let color_value = el.getAttribute('data-value')
        el.classList.add('pd_color_color_bg_' + color_value.toLowerCase().replace(' ', '_'))
        el.children[0].classList.add('pd_color_color_' + color_value.toLowerCase().replace(' ', '_'))
    })

    return true
}

let pd_change_icon_interval_attempts = 0
const pd_change_icon_interval = setInterval(() => {
    pd_change_icon_interval_attempts++

    let r = pd_change_icon()
    if (r) {
        clearInterval(pd_change_icon_interval)
    }


    if (pd_change_icon_interval > 20) {
        clearInterval(pd_change_icon_interval)
    }
}, 50)

;(() => {
  const root = document.getElementById('product_info');
  if (!root) return;

  const product = window.productData;
  const variants = product?.variants || [];
  const section = root.closest('section');
  const sectionId = root.querySelector('[id^="ProductInfo-"]')?.id.slice('ProductInfo-'.length);
  const groupSelector = '[id^="swatch-option"][option-target]';
  const initialized = new Set();
  const storageKey = 'padasnap:phone-model:v1';
  const lifetime = 30 * 24 * 60 * 60 * 1000;
  const incoming = new URLSearchParams(window.location.search);
  const initialVariant = variants.find(variant => String(variant.id) === incoming.get('variant'));
  const memoryEnabled = product?.handle !== 'custom-phone-case';
  const memoryStatus = root.querySelector('.product__model-memory');
  const modelNote = root.querySelector('.product__model-note:not(.product__model-memory)');
  const optionKeys = ['option1', 'option2', 'option3'].filter(key => variants.some(variant => variant[key]));
  const savedModel = memoryEnabled ? readSavedModel() : null;
  let renderedVariant = product?.selected_or_first_available_variant;
  let phoneChoice = null;
  let pendingUserChoice = null;
  let waitingForInfo = false;
  let infoFailed = false;
  let appliedPhoneOption = null;
  let scheduled = false;
  let blocked = false;

  function normalize(value) {
    return String(value || '').trim().replace(/\s+/g, ' ').toLowerCase();
  }

  function isPhoneValue(value) {
    return /^(iphone\b|(?:samsung\s+)?galaxy\b|samsung\b|(?:google\s+)?pixel\b|oneplus\b|huawei\b|xiaomi\b|oppo\b|motorola\b|nothing\s+phone\b|s\d{2}\b|note\s*\d)/i.test(String(value).trim());
  }

  function readSavedModel() {
    try {
      const saved = JSON.parse(window.localStorage.getItem(storageKey));
      if (saved && typeof saved.model === 'string' && saved.model.length <= 100
        && isPhoneValue(saved.model) && Number.isFinite(saved.expiresAt)
        && saved.expiresAt > Date.now() && saved.expiresAt <= Date.now() + lifetime) return saved.model;
    } catch (_) {}
    return null;
  }

  function saveModel(model) {
    try {
      window.localStorage.setItem(storageKey, JSON.stringify({ model, expiresAt: Date.now() + lifetime }));
    } catch (_) {}
  }

  function isModelGroup(group) {
    return isPhoneGroup(group) || /device|model|phone\s*case|airpods\s*case/i.test(group.getAttribute('option-name') || '');
  }

  function groupKey(group) {
    return group.getAttribute('option-target') + ':' + group.getAttribute('option-name');
  }

  function optionsFor(group) {
    return Array.from(group.querySelectorAll('[role="option"], [role="radio"]')).filter(option => optionValue(option));
  }

  function optionValue(option) {
    return option?.getAttribute('orig-value') || option?.getAttribute('value') || '';
  }

  function selectedValue(group) {
    return optionValue(group.querySelector('[role="option"][aria-selected="true"], [role="radio"][aria-checked="true"]'));
  }

  function isPhoneGroup(group) {
    return memoryEnabled && optionKeys.includes(group.getAttribute('option-target'))
      && optionsFor(group).some(option => isPhoneValue(optionValue(option)));
  }

  function mainForm() {
    return root.querySelector('product-form form[data-type="add-to-cart-form"]');
  }

  function selectionVariant(groups) {
    return variants.find(variant => optionKeys.every(key => {
      const group = groups.find(item => item.getAttribute('option-target') === key);
      return group && normalize(selectedValue(group)) === normalize(variant[key]);
    }));
  }

  function priceIsCurrent(variant) {
    return variant && renderedVariant && Number.isFinite(variant.price)
      && variant.available === renderedVariant.available
      && ['price', 'compare_at_price', 'unit_price'].every(key =>
        (variant[key] ?? null) === (renderedVariant[key] ?? null))
      && JSON.stringify(variant.unit_price_measurement || null)
        === JSON.stringify(renderedVariant.unit_price_measurement || null);
  }

  function linkedValue(group, groups) {
    const key = group.getAttribute('option-target');
    if (initialVariant) return initialVariant[key];
    const ids = incoming.get('option_values')?.split(',');
    if (ids?.length === optionKeys.length) {
      const linked = Object.fromEntries(optionKeys.map((optionKey, index) => {
        const optionGroup = groups.find(item => item.getAttribute('option-target') === optionKey);
        const option = optionGroup && optionsFor(optionGroup).find(item => item.getAttribute('option-value-id') === ids[index]);
        return [optionKey, optionValue(option)];
      }));
      if (variants.some(variant => optionKeys.every(optionKey => linked[optionKey] === variant[optionKey]))) return linked[key];
    }
    const value = incoming.get(key);
    return optionsFor(group).find(option => normalize(optionValue(option)) === normalize(value)) && value;
  }

  function placeModelNote(groups) {
    const group = groups.find(isPhoneGroup) || groups.find(item =>
      /^(device|model|phone\s*case)$/i.test(item.getAttribute('option-name') || '')
    );
    const fieldset = group?.querySelector('fieldset');
    const legend = fieldset?.querySelector('legend');
    if (!fieldset || !legend) return;
    let anchor = legend;
    for (const note of [modelNote, memoryStatus]) {
      if (!note) continue;
      if (note.parentElement !== fieldset || note.previousElementSibling !== anchor) anchor.insertAdjacentElement('afterend', note);
      anchor = note;
    }
    const control = group.querySelector('[role="combobox"]');
    if (control) {
      const descriptions = new Set((control.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      [modelNote, memoryStatus].forEach(note => { if (note?.id) descriptions.add(note.id); });
      const value = Array.from(descriptions).join(' ');
      if (control.getAttribute('aria-describedby') !== value) control.setAttribute('aria-describedby', value);
    }
  }

  function setStatus(reason) {
    if (!memoryStatus) return;
    const message = reason === 'unsupported' || reason === 'soldOut'
      ? (memoryStatus.dataset[reason] || '').replace('__model__', phoneChoice?.value || '')
      : reason === 'failed' ? memoryStatus.dataset.failed || '' : '';
    const text = memoryStatus.querySelector('[data-model-message]') || memoryStatus;
    if (text.textContent !== message) text.textContent = message;
    const retry = memoryStatus.querySelector('[data-model-retry]');
    if (retry) retry.hidden = reason !== 'failed';
    memoryStatus.hidden = !message;
    if (modelNote) modelNote.hidden = Boolean(message);
  }

  function setPurchaseGate(reason, variant) {
    blocked = Boolean(reason);
    const form = mainForm();
    const button = form?.querySelector('button[name="add"]');
    if (!button) return;
    if (blocked) {
      if (!button.hasAttribute('data-model-gate')) {
        button.dataset.modelGate = button.textContent.trim();
      }
      if (!button.disabled) button.disabled = true;
      const label = reason === 'pending' ? memoryStatus?.dataset.updating : memoryStatus?.dataset.selectModel;
      if (label && !button.classList.contains('loading') && button.textContent.trim() !== label) button.textContent = label;
    } else if (button.hasAttribute('data-model-gate') || phoneChoice) {
      const label = variant?.available
        ? button.dataset.preOrder === 'true' ? window.variantStrings?.preOrder : window.variantStrings?.addToCart
        : window.variantStrings?.soldOut;
      if (!button.classList.contains('loading')) {
        const readyLabel = label || button.dataset.modelGate;
        if (readyLabel && button.textContent.trim() !== readyLabel) button.textContent = readyLabel;
        button.removeAttribute('data-model-gate');
      }
      const disabled = !variant?.available || Boolean(form.querySelector('input[name="id"]')?.disabled);
      if (button.disabled !== disabled) button.disabled = disabled;
    }
  }

  function syncStickyForm() {
    const form = mainForm();
    const stickyForm = section?.querySelector('.sticky-cart__form form');
    const mainButton = form?.querySelector('button[name="add"]');
    const stickyButton = stickyForm?.querySelector('button[name="add"]');
    const mainVariant = form?.querySelector('input[name="id"]');
    const stickyVariant = stickyForm?.querySelector('input[name="id"]');
    if (!mainButton || !stickyButton || !mainVariant || !stickyVariant) return false;
    if (stickyButton.classList.contains('loading')) return false;
    if (stickyVariant.value !== mainVariant.value) stickyVariant.value = mainVariant.value;
    stickyVariant.disabled = mainVariant.disabled;
    const disabled = blocked || mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true'
      || mainVariant.disabled || !mainVariant.value;
    if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
    const label = mainButton.textContent.trim();
    if (!mainButton.classList.contains('loading') && stickyButton.textContent.trim() !== label) stickyButton.textContent = label;
    return !disabled;
  }

  function initializeModels() {
    scheduled = false;
    const groups = Array.from(root.querySelectorAll(groupSelector));
    const phoneGroup = groups.find(isPhoneGroup);
    placeModelNote(groups);
    groups.forEach(group => {
      if (!isModelGroup(group)) return;
      const key = groupKey(group);
      const options = optionsFor(group);
      if (!options.length) return;
      if (isPhoneGroup(group)) {
        if (!phoneChoice) {
          const linked = linkedValue(group, groups);
          phoneChoice = { value: linked || savedModel || '', source: linked ? 'link' : savedModel ? 'memory' : 'default' };
        }
        if (!phoneChoice.value) {
          const target = options.find(option => option.getAttribute('aria-disabled') !== 'true'
            && variants.some(variant => variant.available
              && normalize(variant[group.getAttribute('option-target')]) === normalize(optionValue(option))
              && groups.every(other => !optionKeys.includes(other.getAttribute('option-target')) || other === group || !selectedValue(other)
                || normalize(variant[other.getAttribute('option-target')]) === normalize(selectedValue(other)))));
          if (target) phoneChoice.value = optionValue(target);
        }
        const target = options.find(option => normalize(optionValue(option)) === normalize(phoneChoice.value));
        if (target && (!initialized.has(key) || appliedPhoneOption !== target)) {
          initialized.add(key);
          appliedPhoneOption = target;
          if (normalize(selectedValue(group)) !== normalize(phoneChoice.value)) {
            infoFailed = false;
            setPurchaseGate('pending');
            target.click();
          }
        }
      } else if (!initialized.has(key)) {
        const available = options.filter(option => option.getAttribute('aria-disabled') !== 'true');
        const requested = linkedValue(group, groups);
        const target = available.find(option => normalize(optionValue(option)) === normalize(requested)) || available[0];
        if (!target) return;
        initialized.add(key);
        if (selectedValue(group) !== optionValue(target)) target.click();
      }
    });

    const variant = selectionVariant(groups);
    const id = mainForm()?.querySelector('input[name="id"]');
    const priceAligned = priceIsCurrent(variant);
    if (priceAligned && waitingForInfo && String(variant.id) !== String(renderedVariant.id)) {
      root.querySelector(`[id="inventory-${sectionId}"]`)?.classList.add('visibility-hidden');
    }
    let reason = '';
    if (phoneGroup && phoneChoice) {
      const supported = optionsFor(phoneGroup).some(option => normalize(optionValue(option)) === normalize(phoneChoice.value));
      if (!supported) reason = 'unsupported';
      else if (normalize(selectedValue(phoneGroup)) !== normalize(phoneChoice.value)) reason = 'pending';
      else if (variant && !variant.available) reason = 'soldOut';
      else if (!variant && optionKeys.every(key => groups.some(group => group.getAttribute('option-target') === key && selectedValue(group)))) reason = 'soldOut';
      else if (infoFailed && !priceAligned) reason = 'failed';
      else if (!variant || String(variant.id) !== id?.value || (waitingForInfo && !priceAligned)) reason = 'pending';
      if (pendingUserChoice && variant && String(variant.id) === id?.value && (!waitingForInfo || priceAligned)
        && normalize(variant[pendingUserChoice.key]) === normalize(pendingUserChoice.value)) {
        saveModel(variant[pendingUserChoice.key]);
        pendingUserChoice = null;
      }
    } else if (savedModel && optionKeys.some(key => variants.some(item => isPhoneValue(item[key])))) reason = 'pending';
    setStatus(reason);
    setPurchaseGate(reason, variant);
    syncStickyForm();
  }

  function scheduleInitialization() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(initializeModels);
  }

  function preserveUserSelection(event) {
    if (!event.isTrusted || !(event.target instanceof Element)) return;
    if (event.type === 'click' && event.target.closest('[data-model-retry]')) {
      infoFailed = false;
      waitingForInfo = true;
      root.querySelector('variant-selects, variant-radios')?.dispatchEvent(new Event('change', { bubbles: true }));
      scheduleInitialization();
      return;
    }
    const nativeSelect = event.type === 'change' && event.target.matches('select') ? event.target : null;
    const optionKey = nativeSelect?.closest('[data-option-index]')?.getAttribute('data-option-index');
    const group = nativeSelect ? Array.from(root.querySelectorAll(groupSelector))
      .find(item => item.getAttribute('option-target') === optionKey) : event.target.closest(groupSelector);
    if (!group || !root.contains(group)) return;
    if (nativeSelect) {
      const option = optionsFor(group).find(item => normalize(optionValue(item)) === normalize(nativeSelect.value));
      if (isPhoneGroup(group) && option) {
        phoneChoice = { value: optionValue(option), source: 'user' };
        pendingUserChoice = { key: optionKey, value: phoneChoice.value };
        infoFailed = false;
        setPurchaseGate('pending');
        scheduleInitialization();
      }
      return;
    }
    let option = event.target.closest('[role="option"], [role="radio"]');
    const confirmKey = event.type === 'keyup' && ['Enter', ' ', 'Spacebar'].includes(event.key);
    const tabCommit = event.type === 'keydown' && event.key === 'Tab'
      && group.querySelector('[role="combobox"][aria-expanded="true"]');
    if (confirmKey || tabCommit) {
      const activeId = group.querySelector('[role="combobox"]')?.getAttribute('aria-activedescendant');
      option = option || optionsFor(group).find(item => activeId && item.id === activeId)
        || group.querySelector('[role="option"].swatch-keyboard-focus, [role="option"]:focus');
    }
    const committed = event.type === 'click' || confirmKey || tabCommit;
    if (!committed || !option || option.getAttribute('aria-disabled') === 'true') return;
    initialized.add(groupKey(group));
    if (isPhoneGroup(group) && isPhoneValue(optionValue(option))) {
      phoneChoice = { value: optionValue(option), source: 'user' };
      pendingUserChoice = { key: group.getAttribute('option-target'), value: phoneChoice.value };
    }
    if (phoneChoice) {
      infoFailed = false;
      setPurchaseGate('pending');
    }
    scheduleInitialization();
  }

  ['click', 'keydown', 'keyup'].forEach(type => root.addEventListener(type, preserveUserSelection, true));
  section?.addEventListener('change', preserveUserSelection, true);
  new MutationObserver(records => {
    if (records.some(record => record.attributeName !== 'class'
      || record.target === mainForm()?.querySelector('button[name="add"]'))) scheduleInitialization();
  }).observe(root, {
    childList: true, subtree: true, attributes: true,
    attributeFilter: ['aria-selected', 'aria-checked', 'disabled', 'aria-disabled', 'value', 'class']
  });
  root.addEventListener('change', scheduleInitialization);
  document.addEventListener('variant:change', event => {
    if (event.detail?.sectionId && event.detail.sectionId !== sectionId) return;
    if (!variants.some(variant => String(variant.id) === String(event.detail?.variant?.id))) return;
    if (phoneChoice) waitingForInfo = true;
    infoFailed = false;
    scheduleInitialization();
  });
  document.addEventListener('productInfo:loaded', event => {
    if (event.detail?.sectionId && event.detail.sectionId !== sectionId) return;
    const id = mainForm()?.querySelector('input[name="id"]')?.value;
    const variant = variants.find(item => String(item.id) === String(event.detail?.variantId));
    if (variant && String(variant.id) === id) {
      renderedVariant = variant;
      waitingForInfo = false;
      infoFailed = false;
    }
    scheduleInitialization();
  });
  document.addEventListener('productInfo:error', event => {
    if (event.detail?.sectionId !== sectionId || !phoneChoice) return;
    const id = mainForm()?.querySelector('input[name="id"]')?.value;
    if (String(event.detail.variantId) === id) {
      const variant = variants.find(item => String(item.id) === id);
      if (!priceIsCurrent(variant)) renderedVariant = null;
      infoFailed = true;
    }
    scheduleInitialization();
  });
  section?.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof Element) || !form.matches('form[data-type="add-to-cart-form"]')) return;
    initializeModels();
    if (blocked || (form.closest('.sticky-cart__form') && !syncStickyForm())) {
      event.preventDefault();
      event.stopImmediatePropagation();
      root.querySelector('[role="combobox"]')?.focus();
    }
  }, true);
  const stickyForm = section?.querySelector('.sticky-cart__form form');
  if (stickyForm) {
    new MutationObserver(scheduleInitialization).observe(stickyForm, {
      subtree: true, attributes: true, attributeFilter: ['class', 'aria-disabled']
    });
  }
  initializeModels();
})();

